<template>
    <div>
        <p v-if="this.$auth.check(['user', 'user.wholesale'])" style="display:none;">{{ getSubscribeProductAction }}</p>
        <nav class="navbar navbar-dark sticky-top bg-dark flex-md-nowrap shadow">
            <router-link tag="a" class="col-md-3 col-lg-2 mr-0 px-3 logo" :to="this.$auth.check(['user', 'user.wholesale']) ? '/order' : ''"><img
                    src="/src/assets/images/logo.png" alt=""></router-link>
            <button class="navbar-toggler position-absolute d-md-none collapsed" type="button" data-toggle="collapse"
                    data-target="#sidebarMenu" aria-controls="sidebarMenu" aria-expanded="false"
                    aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <ul class="navbar-nav flex-row px-3">
                <li class="nav-item" v-if="this.$auth.check(['user', 'user.wholesale'])">
                    <a class="btn btn-primary">
                        <span class="label badge">{{ updated_at }} (обновлено)</span>
                    </a>
                </li>
                <router-link v-if="this.$auth.check(['user', 'user.wholesale']) && getProductsAmount" class="nav-item" active-class="active"
                             tag="li" :to="'/basket'">
                    <a class="btn btn-korzinka">
                        <span>Корзина</span>
                        <span class="label badge badge-light">{{ getProductsAmount }}шт | <span id="total_sum">{{ getTotalPrice | chunk }} ₸</span></span>
                    </a>
                </router-link>
                <li class="nav-item text-nowrap" v-if="this.$auth.check()">
                    <a class="nav-link" @click.prevent="logout" style="cursor:pointer;">
                        <span><font-awesome-icon icon="sign-out-alt"/></span>Выйти</a>
                </li>
            </ul>
        </nav>

        <div class="container-fluid">
            <div class="row">
                <nav id="sidebarMenu" class="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
                    <div class="sidebar-sticky pt-3">
                        <header-c></header-c>
                    </div>
                </nav>

                <main class="col-md-9 ml-sm-auto col-lg-10 px-md-4">
                    <div class="main">
                        <router-view></router-view>
                    </div>
                    <footer-c></footer-c>
                </main>
            </div>
        </div>

    </div>
</template>

<script>

    (function () {
        var widget_id = '5N6RHBnaxx';
        var d = document;
        var w = window;

        function l() {
            var s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = '//code.jivosite.com/script/widget/' + widget_id;
            var ss = document.getElementsByTagName('script')[0];
            ss.parentNode.insertBefore(s, ss);
        }

        if (d.readyState == 'complete') {
            l();
        } else {
            if (w.attachEvent) {
                w.attachEvent('onload', l);
            } else {
                w.addEventListener('load', l, false);
            }
        }
    })();

    import '../../../assets/style/app.scss'
    import HeaderC from '../HeaderComp'
    import FooterC from '../FooterComp'

    import {mapActions, mapGetters} from 'vuex';
    import router from "../../../router";

    export default {
        name: "Index",

        computed: {
            ...mapActions({
                getSubscribeProductAction: 'getSubscribeProduct',
            }),

            ...mapGetters([
                'getProductsAmount',
                'getTotalPrice',
            ]),
        },
        data() {
            return {
                updated_at: null
            }
        },

        methods: {
            ...mapActions({
                changeProductsWithBasketAction: 'changeProductsWithBasket',
            }),

            logout: function () {
                this.$auth.logout()
            },
        },

        mounted() {
            if (!this.$auth.check()) {
                this.$router.push({name: "login"})
            }

            if (this.$auth.check(['user', 'user.wholesale'])){
                this.$auth.user.fetchData;
                if(this.$router.currentRoute.path === '/'){
                    this.$router.push({name: 'Order'})
                }

                this.axios
                    .get(this.axios.defaults.baseURL + 'products')
                    .then(response => {

                        let sortedDate = response.data.products.sort(function (a, b) {
                            if (a.updated_at > b.updated_at) return -1;
                            if (a.updated_at < b.updated_at) return 1;
                            return 0;
                        });

                        this.updated_at = sortedDate[0].updated_at;


                        this.changeProductsWithBasketAction({products: response.data.products}).then(response => {

                        })
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },

        filters: {
            chunk: function (x) {
                var parts = x.toString().split(".");
                parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                return parts.join(".");
            },
        },

        components: {
            HeaderC,
            FooterC
        }
    }
</script>

<style>

    .btn-primary{
        margin-right: 20px;
    }

    .btn-primary span{
        color: #fff;
    }

    .bd-placeholder-img {
        font-size: 1.125rem;
        text-anchor: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    @media (min-width: 768px) {
        .bd-placeholder-img-lg {
            font-size: 3.5rem;
        }
    }

    .feather {
        width: 16px;
        height: 16px;
        vertical-align: text-bottom;
    }

    /*
     * Sidebar
     */

    .sidebar {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        z-index: 100; /* Behind the navbar */
        padding: 60px 0 0; /* Height of navbar */
        box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);

        display: flex!important;
        align-items: flex-end;
    }

    @media (max-width: 767.98px) {
        .sidebar {
            top: 5rem;
        }
    }

    .sidebar-sticky {
        width: 100%;
        position: relative;
        top: 0;
        height: calc(100vh - 65px);
        padding-top: .5rem;
        overflow-x: hidden;
        overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
    }

    @supports ((position: -webkit-sticky) or (position: sticky)) {
        .sidebar-sticky {
            position: -webkit-sticky;
            position: sticky;
        }
    }

    .sidebar .nav-link {
        font-weight: 500;
        color: #333;
    }

    .sidebar .nav-link .feather {
        margin-right: 4px;
        color: #999;
    }

    .sidebar .nav-link.active {
        color: #007bff;
    }

    .sidebar .nav-link:hover .feather,
    .sidebar .nav-link.active .feather {
        color: inherit;
    }

    .sidebar-heading {
        font-size: .75rem;
        text-transform: uppercase;
    }

    /*
     * Navbar
     */

    .navbar-brand {
        padding-top: .75rem;
        padding-bottom: .75rem;
        font-size: 1rem;
        background-color: rgba(0, 0, 0, .25);
        box-shadow: inset -1px 0 0 rgba(0, 0, 0, .25);
    }

    .navbar .navbar-toggler {
        top: .25rem;
        right: 1rem;
    }

    .navbar .form-control {
        padding: .75rem 1rem;
        border-width: 0;
        border-radius: 0;
    }

    .form-control-dark {
        color: #fff;
        background-color: rgba(255, 255, 255, .1);
        border-color: rgba(255, 255, 255, .1);
    }

    .form-control-dark:focus {
        border-color: transparent;
        box-shadow: 0 0 0 3px rgba(255, 255, 255, .25);
    }

</style>



// WEBPACK FOOTER //
// src/views/app/pages/Index.vue